import * as React from 'react';
import ReactDatePicker, {
  ReactDatePickerProps,
  CalendarContainer
} from 'react-datepicker';
import { cn, parseDate } from '../../utils';
import './datePicker.scss';
import { RelativeDate } from '../../enums/RelativeDate';

interface Props {
  withRelativeDate?: boolean;
  onSelectRelative?: (r: RDateValue) => void;
}

type RDateValue = { label: RelativeDate; value: string };
const RelativeDateValue: RDateValue[] = [
  { label: RelativeDate.NextWeek, value: 'P7D' },
  { label: RelativeDate.NextMonth, value: 'P1M' },
  { label: RelativeDate.NextQuarter, value: 'P3M' },
  { label: RelativeDate.NextYear, value: 'P1Y' }
];
const toRelativeDate = (v: string) =>
  RelativeDateValue.filter(r => r.value == v)[0]?.label;

export const DatePicker = <
  CustomModifierNames extends string = never,
  WithRange extends boolean | undefined = undefined
>({
  withRelativeDate,
  ...props
}: Props & ReactDatePickerProps<CustomModifierNames, WithRange>) => {
  const ref = React.useRef(null);
  props.className = 'form-control';
  if (withRelativeDate) {
    let rawValue: string = null;
    if (typeof props.selected == 'string') {
      if (!isNaN(Date.parse(props.selected))) {
        props.selected = parseDate(props.selected);
      } else {
        rawValue = props.selected;
        props.selected = null;
      }
    }
    props.calendarContainer = ({ className, children }) => {
      return (
        <CalendarContainer className={className}>
          <div className="relative-date-picker">
            <div className="rdp-relative">
              {RelativeDateValue.map(r => {
                return (
                  <div
                    className={cn(
                      { 'rdp-selected': rawValue == r.value },
                      'dropdown-item'
                    )}
                    onClick={() => {
                      props.onSelectRelative(r);
                      ref?.current?.setOpen(false);
                    }}
                  >
                    {r.label}
                  </div>
                );
              })}
            </div>
            <div className="rdp-date">{children}</div>
          </div>
        </CalendarContainer>
      );
    };
    props.customInput = <RelativeInput rawValue={rawValue} />;
  }
  /** @ts-ignore */
  return <ReactDatePicker ref={ref} {...props} dateFormat={'dd MMM yyyy'} />;
};

const RelativeInput = ({ onBlur, value, rawValue, ...props }: any) => {
  rawValue = toRelativeDate(rawValue) || rawValue;
  return (
    <input
      {...props}
      value={rawValue || value}
      onChange={e => {
        console.log('onChange', e.target.value);
      }}
    />
  );
};
